<template>
  <p class="clearfix mb-0">
    <span class="float-md-right d-block d-md-inline-block mt-25">
      کلیه حقوق متعلق به مجموعه
      <b-link
        class="ml-25"
        href="http://zirehapp.com"
        target="_blank"
      > زیره </b-link>
      <span class="d-none d-sm-inline-block">می‌باشد.</span>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
